import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IRoomTariff } from "../../models/BaseModel";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { baseUrl } from "../../shared/Fetch";
import { FileUpload } from "primereact/fileupload";
import { JVDropdown } from "../../shared/JVDropdown";

const schema = yup.object({
    roomType: yup.string().min(1).required("Room Type is required*"),
    roomPlan: yup.string().min(1).required("Room Type is required*")

});

interface Iprops {
    singleData: IRoomTariff,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Form = (props: Iprops) => {
    const [saveDis, setSaveDis] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [imageType, setImageType] = useState<string>("");
    const [image, setImage] = useState(false);
    const [resumeFile, setResumeFile] = useState<File | null | any>(null);
    const { control, handleSubmit, formState: { errors }, reset } = useForm<IRoomTariff>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false,
    });

    const roomType = [{ name: "Baula - Premium" },
    { name: "Kingfisher- Deluxe" },
    { name: "Olive Ridley" },
    { name: "Mangrove Pitta" }
    ]

    const roomPlan = [{ name: "EP (European Plan)" },
    { name: "CP (Continental Plan)" },
    { name: "MAP (Modified American Plan)" },
    { name: "AP (American Plan)" }
    ]

    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData]);

    const saveToDB = async (data: IRoomTariff) => {
        const message = props.singleData.id != null ? "Updated Successfully" : "Added Successfully";
        const method = props.singleData.id != null ? "PUT" : "POST";
        const formData = new FormData();
        formData.append('images', resumeFile);
        formData.append('roomTariff', JSON.stringify(data));
        const params = {
            method: method,
            headers: {
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            },
            body: formData
        };
        const response = await fetch(`${baseUrl}RoomTariff?typeoffile=${imageType}`, params);
        if (response) {
            props.hideDialog();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            setSaveDis(false);
            props.reloadData();
        } else {
            setSaveDis(false);
        }
        setImage(false);
        setResumeFile(null)
    }

    const onHide = () => {
        props.hideDialog();
        reset({});
    }

    function onSubmit(data: IRoomTariff) {
        console.log(image)
        if (!image && (props.singleData.id === null || props.singleData.id === undefined)) {
            props.toast.current?.show({ severity: 'error', detail: "Please Upload Image First!", life: 3000 });
        }
        else {
            saveToDB(data);
        }
    }

    const onUpload = (event: any) => {
        const file = event.files[0];
        setImageType(event.files[0].type.split("/")[1]);

        if (event.files[0].type === "image/png" || event.files[0].type === "image/jpeg" || event.files[0].type === "image/jpg") {
            if (event.files[0].size > 1024 * 1024 * 2) {
                props.toast.current.show({ severity: 'error', content: "Image File should be less than 2 MB." });
                event.options.clear();
            } else {
                setResumeFile(file);
                setImage(true);
                event.options.clear();
            }
        } else {
            props.toast.current.show({ severity: 'error', content: "Please Choose A Image File." });
            setImage(true);
            event.options.clear();
        }

        setResumeFile(file);
        props.toast.current.show({ severity: 'success', summary: 'Success', detail: "Screenshot Saved", life: 3000 });

    };

    return (
        <Dialog visible={props.open} style={{ width: '80vw', maxWidth: '600px' }} header="Add/Edit Room Tariff" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVDropdown required label="Room Type" control={control} options={roomType} optionLabel="name" optionValue="name" name="roomType" placeholder="Select Room Type" error={errors.roomType?.message} />
                <JVDropdown required label="Room Plan" control={control} options={roomPlan} optionLabel="name" optionValue="name" name="roomPlan" placeholder="Select Room Plan" error={errors.roomPlan?.message} />
                <div className="card flex justify-content-center">
                    <FileUpload chooseLabel="Choose Image" mode="basic" name="image" accept="image/*" customUpload uploadHandler={onUpload} auto />
                </div>
                <div className="col-12 md:col-12 flex gap-4 justify-content-end mt-2">
                    <Button style={{ width: '100px' }} loading={submitting} label="SAVE" type="submit" className="p-button-rounded"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>
                </div>
            </form>
        </Dialog>
    );
}